"use strict";

var CustomSigns = require('./CustomSigns');

var FavorTags = require('./FavorTags');

var PlaceCards = require('./PlaceCards');

var ReservedSigns = require('./ReservedSigns');

var SeatingCharts = require('./SeatingCharts');

var TableNumbers = require('./TableNumbers');

var WeddingMenus = require('./WeddingMenus');

var WeddingSigns = require('./WeddingSigns');

var WelcomeSigns = require('./WelcomeSigns');

module.exports = {
  CustomSigns: CustomSigns,
  FavorTags: FavorTags,
  PlaceCards: PlaceCards,
  ReservedSigns: ReservedSigns,
  SeatingCharts: SeatingCharts,
  TableNumbers: TableNumbers,
  WeddingMenus: WeddingMenus,
  WeddingSigns: WeddingSigns,
  WelcomeSigns: WelcomeSigns,
  CustomSignReprints: CustomSigns,
  FavorTagReprints: FavorTags,
  PlaceCardReprints: PlaceCards,
  ReservedSignReprints: ReservedSigns,
  SeatingChartReprints: SeatingCharts,
  TableNumberReprints: TableNumbers,
  WeddingMenuReprints: WeddingMenus,
  WeddingSignReprints: WeddingSigns,
  WelcomeSignReprints: WelcomeSigns
};